import consumerApi from "@/api/services/consumer-api";
import consumerApiCa from "@/api/services/consumer-api-ca";
import logError from "@/utils/logError";

type Params = {
  atmosphereRating: number | null | string;
  isFirstVisit: boolean;
  qualityRating: number | null | string;
  serviceRating: number | null | string;
  text: string | null;
  wouldRecommend: boolean;
  wouldShopAgain: boolean;
};

export const postDispensaryReview: (
  dispensarySlug: string,
  domainCountryCode: string,
  params: Params,
) => Promise<boolean> = async (
  dispensarySlug: string,
  domainCountryCode: string,
  params: Params,
) => {
  const consumerApiClient =
    domainCountryCode === "CA" ? consumerApiCa : consumerApi;
  try {
    await consumerApiClient.post(
      `/api/dispensary_reviews/v1/${dispensarySlug}`,
      {
        dispensaryReview: {
          isLicensedProvider: false,
          ...params,
        },
      },
    );

    return true;
  } catch (e) {
    logError(e.message, {
      functionName: "postDispensaryReview",
      service: "consumer",
      statusCode: e.statusCode,
    });
    return false;
  }
};
